<ng-select class="mat-form-field ng-select" appearance="fill"
           [items]="filteredItems"
           [maxSelectedItems]="maxSelectedItemsCount"
           [bindLabel]="bindLabel"
           [bindValue]="bindValue"
           [multiple]="IS_MULTIPLE"
           (search)="onSearch($event)"
           (close)="close.emit()"
           (change)="setValue($event)"
           [notFoundText]="notFoundText"
           [closeOnSelect]="closeOnSelect"
           [ngModel]="selectedItems"
           [compareWith]="compareHashtagsWithId"
           [placeholder]="(!selectedItems || selectedItems.length === 0) ? (label | translate) : ''"
           [attr.data-label]="label"
           [clearable]="IS_CLEARABLE"
           [searchable]="true"
           (open)="onOpen()"
>

  <ng-template ng-option-tmp let-item="item">
    <div class="flex-direction-row" style="gap: 16px">
      <div class="is-selected-hashtag">
        @if (isSelectedById(item.id)) {
          <mat-icon class="selected-hashtag-check">check</mat-icon>
        }
      </div>
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
  <ng-template ng-footer-tmp>
    @if (showSeeMoreButton) {
      <button (click)="onLoadMore()" [disabled]="isLoading" class="show-more-button-container">
        @if (!isLoading) {
          <span class="show-more-button">{{ 'my_team.load_more' | translate }}</span>
        }
        @if (isLoading) {
          <span class="loading">Loading...</span>
        }
      </button>
    }
  </ng-template>
</ng-select>
